/**
 * @generated SignedSource<<7e31aeedc8f0b6d30abedae40b194282>>
 * @relayHash a912afe2fbea3fe5bd99ea14ca3598df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80dee9f42627028b3fd3b3f9eb8acb3b8bd154a05615cec731d0c14c85c65b4b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type usePersistentInviteButtonEligibleLicenseDetailsQuery$variables = Record<PropertyKey, never>;
export type usePersistentInviteButtonEligibleLicenseDetailsQuery$data = {
  readonly license: {
    readonly licenseConsumingUserCount: number;
    readonly trialEndDate: string | null | undefined;
  } | null | undefined;
};
export type usePersistentInviteButtonEligibleLicenseDetailsQuery = {
  response: usePersistentInviteButtonEligibleLicenseDetailsQuery$data;
  variables: usePersistentInviteButtonEligibleLicenseDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "License",
    "kind": "LinkedField",
    "name": "license",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "licenseConsumingUserCount"
      },
      {
        "kind": "ScalarField",
        "name": "trialEndDate"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a912afe2fbea3fe5bd99ea14ca3598df",
    "id": "80dee9f42627028b3fd3b3f9eb8acb3b8bd154a05615cec731d0c14c85c65b4b",
    "metadata": {},
    "name": "usePersistentInviteButtonEligibleLicenseDetailsQuery",
    "operationKind": "query",
    "text": "query usePersistentInviteButtonEligibleLicenseDetailsQuery{license{licenseConsumingUserCount,trialEndDate}}"
  }
};
})();

(node as any).hash = "ba822387cdd604c4581f577b0c57ca7a";

export default node;
